export default "__VITE_ASSET__BzIjMaFk__"